export enum ColumnChartName {
	Risk = 'risk',
	Exposure = 'exposure',
	GroupedColumnChart = 'grouped-column-chart',
	NileExposure = 'nile-exposure',
	NileRisk = 'nile-risk',
	GainLossChart = 'gain-loss-chart',
	IqAnalyticsChart = 'iq-analytics-chart',
	IqAnalyticsStacked = 'iq-analytics-stacked',
	IretireAnnuityChart = 'iretire-annuity-chart',
	IqUpsideDownsideChart = 'iq-upside-downside-chart',
	PaCustomColumnChart = 'pa-custom-column-chart',
	IretireDecumHistogramChart = 'iretire-decum-histogram-chart',
	UpsideDownsideChart = 'upside-downside-chart',
	EsgUplift = 'me-esg-uplift'
}
